import React from "react";
import "./penawaranbalik.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

const penawaranbalik = () => {
  const waabout = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send?phone=62895417144022&text=Halo%20Sandy,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20rumah%20ini%20()%20(https://marketing-grandwisatabekasi.com/)%20?&fbclid=PAAaa7g9IJ-tB3RyMunLD6w_5ysqP4oI6PA2d9Ml7Isc1_OXjeOiGuAqu7Ap0";
    window.location.href = whatsappLink;
  };
  return (
    <div className="penawaranbalik">
      <div className="container-penawaranbalik">
        <div className="header1">Konsultasi Gratis Property Impian Kamu!</div>
        <div className="desk1">
          Ikuti konsultasi gratis ini, Kamu dapat memperoleh pemahaman yang
          lebih baik tentang properti, KPR Bank Serta Promo yang didapat. FREE!
          Tidak dipungut biaya apapun.
        </div>
        <div className="button">
          <button onClick={waabout} className="whatsapp">
            <FontAwesomeIcon icon={faWhatsapp} /> Hubungi Kami
          </button>
        </div>
      </div>
    </div>
  );
};

export default penawaranbalik;
